module.exports = __webpack_public_path__ + "static/media/merge-values.78e6d63e.png";